/**
 * Image + Text cards – class-based web component, Swiper slider.
 * Uses <custom-image-text-cards> and .custom-image-text-cards-* classes.
 */
(function () {
  class CustomImageTextCards extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
    }

    init() {
      if (typeof window.Swiper === 'undefined' || this.swiper) return;

      const sliderEl = this.querySelector('.custom-image-text-cards__slider');
      if (!sliderEl) return;

      const prevEl = sliderEl.querySelector('.swiper-button-prev');
      const nextEl = sliderEl.querySelector('.swiper-button-next');

      this.swiper = new window.Swiper(sliderEl, {
        speed: 300,
        slidesPerView: 'auto',
        loop: false,
        wrapperClass: 'custom-image-text-cards__wrapper',
        slideClass: 'custom-image-text-cards__slide',
        navigation:
          prevEl && nextEl
            ? { nextEl: nextEl, prevEl: prevEl }
            : false,
      });
    }

    connectedCallback() {
      if (typeof window.Swiper !== 'undefined') {
        this.init();
        return;
      }
      const onSwiper = () => {
        window.removeEventListener('load', onSwiper);
        if (typeof window.Swiper !== 'undefined') this.init();
      };
      window.addEventListener('load', onSwiper);
    }

    disconnectedCallback() {
      if (this.swiper && this.swiper.destroy) {
        this.swiper.destroy(true, true);
        this.swiper = null;
      }
    }
  }

  if (!customElements.get('custom-image-text-cards')) {
    customElements.define('custom-image-text-cards', CustomImageTextCards);
  }
})();
